// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import {
//   Box,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Select,
//   Button,
//   Dialog,
//   DialogTitle,
//   Pagination,
//   DialogContent,
//   DialogContentText,
//   Typography,
//   DialogActions,
//   IconButton,
// } from '@mui/material';
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import FieldData from './FieldData';
// import SearchImg from '../../assets/search.svg';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import * as XLSX from 'xlsx';
// import Book1Client from '../../assets/excel/Book1Client.xlsx';
// import TextInputs from 'src/components/inputs/TextInputs';
// import ClinetSuggestion from '../Appointments/ClinetSuggestion';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import { useLocation } from 'react-router';
// import Cfilter from './Cfilter';
// import { ClearIcon } from '@mui/x-date-pickers-pro';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setClients,
//   setLoading,
//   setPage,
//   setLimit,
//   setSearch,
//   setSortBy,
//   setGenderBy,
//   setShowLossClient,
//   setCheckedClients,
//   clearFilters,
// } from '../../redux/slices/clientSlice';

// const filterMenu = [
//   { value: 'billsFrequency', label: 'Most Frequent' },
//   { value: 'totalBillsAmount', label: 'Highest billed' },
//   { value: 'ratings', label: 'Ratings' },
// ];

// const filterGenderWise = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
// ];

// const AllClients = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const { fetchAllClients, getAllLossClient, activeBranchId, createManyClient, sendBulkSms, setShowMessage, walletPayment } =
//     useMain();

//   const dispatch = useDispatch();
//   const {
//     clients,
//     filteredClients,
//     loading,
//     pagination,
//     filters,
//     checkedClients,
//   } = useSelector((state) => state.clients);

//   const { state } = useLocation();

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       // Read the file using XLSX
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });

//         // Assuming the first sheet contains the data
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

//         // Convert the sheet data to JSON
//         const jsonData = XLSX.utils.sheet_to_json(firstSheet);
//         //  console.log(jsonData,'jsonnnnnnnnn')
//         // Set the converted data in state
//         setUploadedData(jsonData);
//       };
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };

//   useEffect(() => {
//     dispatch(clearFilters());

//     return () => {
//       // Reset filters when component unmounts
//       dispatch(clearFilters());
//     };
//   }, [dispatch]);

//   const getData = async (lossClients = false) => {
//     try {
//       dispatch(setLoading(true));
//       const res = lossClients
//         ? await getAllLossClient(activeBranchId)
//         : await fetchAllClients(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setClients(res.data));
//       } else {
//         setShowMessage({ message: res.message || 'Failed to fetch clients', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Failed to fetch clients', messageType: 'error' });
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getData(filters.showLossClient);
//     }
//   }, [activeBranchId, filters.showLossClient]);

//   const handleLimitChange = (e) => {
//     dispatch(setLimit(Number(e.target.value)));
//   };

//   const handleFilterChange = (selectedValues) => {
//     const selectedSortBy = selectedValues.filter(val => filterMenu.some(opt => opt.value === val));
//     const selectedGenderBy = selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val));

//     dispatch(setSortBy(selectedSortBy));
//     dispatch(setGenderBy(selectedGenderBy));
//   };



//   const toggleClientType = () => {
//     dispatch(setShowLossClient(!filters.showLossClient));
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (!uploadedData) {
//       setShowMessage({ message: 'Please select a valid file', messageType: 'error' });
//       return;
//     }
//     try {
//       dispatch(setLoading(true));
//       const res = await createManyClient(
//         activeBranchId,
//         JSON.stringify({ bulkData: uploadedData }),
//       );
//       if (res?.statusCode === 200) {
//         getData();
//         setShowMessage({
//           message: res.message || 'Bulk client upload successful',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({
//           message: res.message || 'Bulk client upload failed',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Bulk client upload failed',
//         messageType: 'error',
//       });
//     } finally {
//       dispatch(setLoading(false));
//       closeModal();
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const templateFileName = Book1Client;

//     // Create an anchor element to trigger the download
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = templateFileName;
//     a.download = 'client_template.xlsx';

//     // Trigger the click event to download the file
//     document.body.appendChild(a);
//     a.click();

//     // Remove the anchor element
//     document.body.removeChild(a);
//   };

//   const sendBulkSmsHandler = async () => {
//     const bulkNumber = checkedClients.map((client) => client.clientNumber);
//     try {
//       const res = await sendBulkSms({ bulkNumber });
//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Bulk SMS sent successfully',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({ message: res.message || 'Bulk SMS not sent', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     }
//   };


//   return (
//     <PageContainer title="Client History" description="This contains all products">
//       <DashboardCard2 title="Client Management">
//         <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1.5rem', alignItems: 'start' }}>
//           <div style={{ marginBottom: '1.7rem' }}>
//             <InputLabel>Show per page</InputLabel>
//             <Select
//               style={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 padding: '4px 12px',
//                 background: '#FFF',
//                 height: '40px',
//                 width: '17%'
//               }}
//               value={pagination.limit}
//               onChange={handleLimitChange}
//             >
//               <MenuItem value={10}>10</MenuItem>
//               <MenuItem value={50}>50</MenuItem>
//               <MenuItem value={100}>100</MenuItem>
//               <MenuItem value={200}>200</MenuItem>
//             </Select>
//           </div>

//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', alignItems: 'center' }}>


//             <div style={{ marginRight: '4rem', width: '98%' }}>
//               <Cfilter
//                 options={[
//                   { title: 'Sort By', items: filterMenu },
//                   { title: 'Gender', items: filterGenderWise }
//                 ]}
//                 value={[...filters.genderBy, ...filters.sortBy]}  // Spread both arrays to merge their values
//                 onChange={handleFilterChange}
//                 placeholder="Filters"
//                 style={{ marginRight: '1rem' }}
//               />
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '0.6rem' }} onClick={() => document.getElementById('search-input').focus()}>
//               <InputLabel style={{ marginLeft: '-5rem' }}>Search</InputLabel>
//               <div className="search-input" style={{ display: 'flex', width: '150px', marginLeft: '0.5rem' }}>
//                 <img src={SearchImg} alt="" />
//                 <input
//                   id="search-input"
//                   type="text"
//                   placeholder=""
//                   value={filters.search}
//                   onChange={(e) => dispatch(setSearch(e.target.value))}
//                   style={{ marginLeft: '0.5rem', borderRadius: '5px' }}
//                 />
//                 {filters.search && (
//                   <IconButton
//                     onClick={() => {
//                       dispatch(setSearch(''));
//                     }}
//                     style={{ padding: 1 }}
//                   >
//                     <ClearIcon style={{
//                       // color: '#ff4d4d',
//                       color: '#000',
//                       // color: '#A2A3AE',
//                       marginRight: '-0.2rem', marginTop: '0.1rem',
//                       fontSize: '1.1rem'
//                     }} />
//                   </IconButton>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>


//         <Grid container justifyContent="flex-end" spacing={2}>
//           <Grid item>
//             <Button
//               variant="contained"
//               color="primary"
//               sx={{ background: filters.showLossClient ? '#6174DD' : '#FF6B6B' }}
//               onClick={toggleClientType}
//             >
//               {filters.showLossClient ? 'All Clients' : 'Lost Clients'}
//             </Button>
//           </Grid>
//           <Grid item>
//             <Button
//               variant="contained"
//               color="primary"
//               target="_blank"
//               sx={{ background: '#6174DD' }}
//               onClick={openModal}
//             >
//               Bulk Client Upload
//             </Button>
//           </Grid>
//         </Grid>

//         {/*----------------------Modal Dialog-------------------*/}
//         <Dialog open={isModalOpen} onClose={closeModal}>
//           <DialogTitle>Create Many Client</DialogTitle>
//           <form onSubmit={handleFormSubmit}>
//             <Box p={2}>
//               <input
//                 type="file"
//                 accept=".xlsx, .xls" // Set accepted file types
//                 onChange={handleFileChange}
//               />
//             </Box>
//             {loading && <ShowLoader value={loading} />}
//             <Box p={2}>
//               <Button type="submit" variant="contained" color="primary">
//                 Submit
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 sx={{ ml: 2 }}
//                 onClick={downloadExcelTemplate}
//               >
//                 <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
//                 Sample Download
//               </Button>
//             </Box>
//           </form>
//         </Dialog>

//         {/* -------------------------table start-------------------------- */}

//         {loading ? (
//           <ShowLoader />
//         ) : filteredClients && filteredClients.length > 0 ? (
//           <>
//             <Box>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} lg={12}>
//                   {/* Use the fetched client data instead of the static data */}
//                   <FieldData
//                     getData={() => getData(filters.showLossClient)}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           </>
//         ) : (
//           'No data found'
//         )}

//         {/* <Box display={'flex'} justifyContent={'flex-end'}>
//           <Pagination
//             count={Math.ceil(data.length / limit)}
//             page={page}
//             color="primary"
//             onChange={(e, page) => setPage(page)}
//             disabled={data.length === 0}
//           />
//         </Box> */}
//         {/* Pagination */}
//         <Box display={'flex'} justifyContent={'flex-end'} mt={2}>
//           <Pagination
//             count={Math.ceil(pagination.total / pagination.limit)}
//             page={pagination.page}
//             color="primary"
//             onChange={(e, newPage) => dispatch(setPage(newPage))}
//             disabled={pagination.total === 0}
//           />
//         </Box>


//         {checkedClients.length !== 0 && (
//           <Box
//             style={{
//               width: '100%',
//               display: 'flex',
//               justifyContent: 'flex-end',
//               marginTop: '20px',
//             }}
//           >
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 gap: '10px',
//                 margin: '10px 0px 0px 0px',
//               }}
//             >
//               <div style={{ width: '200px' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   target="_blank"
//                   sx={{
//                     background: '#25d366',
//                     '&:hover': { background: '#25d366' },
//                   }}
//                 >
//                   <WhatsAppIcon sx={{ margin: '0 5px' }} />
//                   Bulk WhatsApp
//                 </Button>
//               </div>
//               <div style={{ width: '200px' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   target="_blank"
//                   sx={{
//                     background: '#6174DD',
//                   }}
//                   onClick={sendBulkSmsHandler}
//                 >
//                   Send Bulk Sms
//                 </Button>
//               </div>
//             </div>
//           </Box>
//         )}
//       </DashboardCard2>
//     </PageContainer >
//   );
// };

// export default AllClients;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Dialog,
  DialogTitle,
  Pagination,
  IconButton,
  Alert,
  Snackbar,
  DialogActions,
  Chip,
  Typography,
  DialogContent,
  LinearProgress,
  CardContent,
} from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import FieldData from './FieldData';
import SearchImg from '../../assets/search.svg';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import * as XLSX from 'xlsx';
import Book1Client from '../../assets/excel/Book1Client.xlsx';
import TextInputs from 'src/components/inputs/TextInputs';
import ClinetSuggestion from '../Appointments/ClinetSuggestion';
import RadioInputs from 'src/components/inputs/RadioInputs';
import { useLocation } from 'react-router';
import Cfilter from './Cfilter';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { useDispatch, useSelector } from 'react-redux';
import {
  setClients,
  setLoading,
  setPage,
  setLimit,
  setSearch,
  setSortBy,
  setGenderBy,
  setShowLossClient,
  setCheckedClients,
  clearFilters,
  clearCheckedClients
} from '../../redux/slices/clientSlice';
import { Card } from 'reactstrap';
import TemplateSelectionDialog from '../Billings/Templates/TemplateSelectionDialog';
import BulkUploadClientDialog from './components/BulkUploadClientDialog'; 


const filterMenu = [
  { value: 'billsFrequency', label: 'Most Frequent' },
  { value: 'totalBillsAmount', label: 'Highest billed' },
  { value: 'ratings', label: 'Ratings' },
  { value: 'showLossClient', label: 'Show Lost Client' } // Add this line
];

const filterGenderWise = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
];

// In your AllClients component - UPDATE filter structure
const filterOptions = [
  {
    title: 'Sort By',
    items: [
      { value: 'billsFrequency', label: 'Most Frequent' },
      { value: 'totalBillsAmount', label: 'Highest billed' },
      { value: 'ratings', label: 'Ratings' },
    ]
  },
  {
    title: 'Gender',
    items: filterGenderWise
  },
  {
    title: 'Client Type',
    items: [
      { value: 'showLossClient', label: 'Show Lost Client' }
    ]
  }
];

const AllClients = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);


  const [openWhatsAppDialog, setOpenWhatsAppDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateVariables, setTemplateVariables] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(0);
  const [sendError, setSendError] = useState(null);
  const [validationError, setValidationError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const {
    fetchAllClients,
    getAllLossClient,
    activeBranchId,
    createManyClient,
    setShowMessage,
    sendBulkWhatsApp,
    getWhatsAppTemplates,
    branchData,
  } = useMain();

  const dispatch = useDispatch();
  const {
    clients,
    filteredClients,
    loading,
    pagination,
    filters,
    checkedClients,
  } = useSelector((state) => state.clients);

  const { state } = useLocation();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Read the file using XLSX
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Assuming the first sheet contains the data
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

        // Convert the sheet data to JSON
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        //  console.log(jsonData,'jsonnnnnnnnn')
        // Set the converted data in state
        setUploadedData(jsonData);
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  useEffect(() => {
    dispatch(clearFilters());

    return () => {
      // Reset filters when component unmounts
      dispatch(clearFilters());
    };
  }, [dispatch]);

  const getData = async (lossClients = false) => {
    try {
      dispatch(setLoading(true));
      const res = lossClients
        ? await getAllLossClient(activeBranchId)
        : await fetchAllClients(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setClients(res.data));
      } else {
        setShowMessage({ message: res.message || 'Failed to fetch clients', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Failed to fetch clients', messageType: 'error' });
    } finally {
      dispatch(setLoading(false));
    }
  };
const fuzzyMatch = (text, search) => {
  if (!search) return true;
  const lowerText = text?.toLowerCase().replace(/\s/g, '');
  if (!lowerText) return false;

  const lowerSearch = search.toLowerCase().replace(/\s/g, '');

  let textIndex = 0;
  let searchIndex = 0;
  while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
    if (lowerText[textIndex] === lowerSearch[searchIndex]) {
      searchIndex++;
    }
    textIndex++;
  }
  return searchIndex === lowerSearch.length;
};
  useEffect(() => {
    if (activeBranchId) {
      getData(filters.showLossClient);
    }
  }, [activeBranchId, filters.showLossClient]); // This should trigger API call

  const handleLimitChange = (e) => {
    dispatch(setLimit(Number(e.target.value)));
  };

  // const handleFilterChange = (selectedValues) => {
  //   const selectedSortBy = selectedValues.filter(val => filterMenu.some(opt => opt.value === val));
  //   const selectedGenderBy = selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val));

  //   dispatch(setSortBy(selectedSortBy));
  //   dispatch(setGenderBy(selectedGenderBy));
  // };
  // ✅ MODIFY filter handler to preserve selection
  // const handleFilterChange = (selectedValues) => {
  //   const selectedSortBy = selectedValues.filter(val => filterMenu.some(opt => opt.value === val));
  //   const selectedGenderBy = selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val));

  //   dispatch(setSortBy(selectedSortBy));
  //   dispatch(setGenderBy(selectedGenderBy));
  //   // Selection automatically preserve hoga
  // };

  // IMPROVED handleFilterChange function
  const handleFilterChange = (selectedValues) => {
    const selectedSortBy = selectedValues.filter(val =>
      filterMenu.some(opt => opt.value === val && opt.value !== 'showLossClient')
    );
    const selectedGenderBy = selectedValues.filter(val =>
      filterGenderWise.some(opt => opt.value === val)
    );

    // Handle Loss Client checkbox separately
    const showLossClient = selectedValues.includes('showLossClient');

    dispatch(setSortBy(selectedSortBy));
    dispatch(setGenderBy(selectedGenderBy));
    dispatch(setShowLossClient(showLossClient));

    // Trigger API call immediately when loss client filter changes
    if (activeBranchId) {
      getData(showLossClient);
    }
  };



  const toggleClientType = () => {
    dispatch(setShowLossClient(!filters.showLossClient));
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!uploadedData) {
      setShowMessage({ message: 'Please select a valid file', messageType: 'error' });
      return;
    }
    try {
      dispatch(setLoading(true));
      const res = await createManyClient(
        activeBranchId,
        JSON.stringify({ bulkData: uploadedData }),
      );
      if (res?.statusCode === 200) {
        getData();
        setShowMessage({
          message: res.message || 'Bulk client upload successful',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Bulk client upload failed',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Bulk client upload failed',
        messageType: 'error',
      });
    } finally {
      dispatch(setLoading(false));
      closeModal();
    }
  };

  const downloadExcelTemplate = () => {
    // Define headers for the Excel template
    const headers = ['clientName', 'clientNumber', 'clientEmail', 'address', 'gender', 'birthday', 'anniversary'];

    // Add GST fields if branch has a GST number
    if (branchData?.gstNumber) {
      headers.push('clientGstNumber', 'clientPos');
    }

    // Create a sample data structure with the provided sample data
    const sampleData = [
      {
        clientName: 'test 4 branch',
        clientNumber: '1234567890',
        clientEmail: 'client1@gmail.com',
        address: 'xyz',
        gender: 'male',
        birthday: '18/11/2022',
        anniversary: '10/11/2022',
      },
      {
        clientName: 'test 5 branch',
        clientNumber: '1234567891',
        clientEmail: 'client2@gmail.com',
        address: 'xyz',
        gender: 'female',
        birthday: '19/11/2022',
        anniversary: '11/11/2022',
      },
      {
        clientName: 'test 6 branch',
        clientNumber: '1234567892',
        clientEmail: 'client1@gmail.com',
        address: 'xyz',
        gender: 'male',
        birthday: '20/11/2022',
        anniversary: '12/11/2022',
      },
    ];

    // Add placeholder GST data if the branch has GST enabled
    if (branchData?.gstNumber) {
      sampleData.forEach((row) => {
        row.clientGstNumber = '07AAAAA0000A1Z5';
        row.clientPos = 'Delhi (07)';
      });
    }

    const worksheet = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Clients');

    // Trigger dynamic download
    XLSX.writeFile(workbook, 'client_template.xlsx');
  };

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  // Validate phone numbers
  const validatePhoneNumbers = (clients) => {
    const invalidNumbers = clients.filter(client => {
      const number = client.clientNumber.toString().replace(/\D/g, '');
      return number.length < 10 || number.length > 15;
    });

    if (invalidNumbers.length > 0) {
      return `Invalid phone numbers found: ${invalidNumbers.map(c => c.clientNumber).join(', ')}`;
    }
    return null;
  };

  // Prepare WhatsApp payload with proper variable segregation
  const prepareWhatsAppPayload = (template, clients) => {
    if (!template || !clients || clients.length === 0) {
      throw new Error('Template or clients data is missing');
    }

    const numbers = clients.map((client) => {
      const number = client.clientNumber.toString().replace(/\D/g, '');
      return number.startsWith('91') ? number : `${number}`;
    });

    const payload = {
      numbers: numbers,
      template_name: template.name,
    };

    // Separate body and button variables (skip header variables)
    const bodyVariables = {};
    const buttonVariables = {};

    template.variables.forEach((variable, index) => {
      // Skip header variables — they are handled via file upload
      const varType = template.variableTypes?.[variable];
      if (varType && varType.type !== 'text') return;

      const varKey = `var_${index + 1}`;
      const value = template.variableValues?.[varKey] || '';

      if (variable.toLowerCase().includes('button')) {
        const buttonIndex = variable.split('_')[1] || (index + 1);
        buttonVariables[`button${buttonIndex}`] = value;
      } else {
        const bodyIndex = variable.split('_')[1] || (index + 1);
        bodyVariables[`var${bodyIndex}`] = value;
      }
    });

    // Merge body and button variables into payload
    Object.assign(payload, bodyVariables, buttonVariables);

    // Include headerFile if present
    if (template.headerFile) {
      payload.headerFile = template.headerFile;
    }

    return payload;
  };

  // Updated WhatsApp sending function with validation
  const handleSendBulkWhatsApp = async () => {
    try {
      // Validation checks
      if (!selectedTemplate) {
        throw new Error('Please select a WhatsApp template');
      }

      if (!checkedClients || checkedClients.length === 0) {
        throw new Error('No clients selected for WhatsApp messaging');
      }

      const phoneValidationError = validatePhoneNumbers(checkedClients);
      if (phoneValidationError) {
        throw new Error(phoneValidationError);
      }

      // Validate template variables (skip header variables)
      const missingVariables = selectedTemplate.variables.filter((variable, index) => {
        const varType = selectedTemplate.variableTypes?.[variable];
        if (varType && varType.type !== 'text') return false; // skip header vars
        const varKey = `var_${index + 1}`;
        return !selectedTemplate.variableValues?.[varKey]?.trim();
      });

      if (missingVariables.length > 0) {
        throw new Error(`Please fill all template variables: ${missingVariables.join(', ')}`);
      }

      // Prepare payload
      const payload = prepareWhatsAppPayload(selectedTemplate, checkedClients);

      console.log('Final Payload:', payload);

      // Start sending process
      setIsSending(true);
      setSendProgress(0);
      setSendError(null);

      // Simulate progress updates
      const progressInterval = setInterval(() => {
        setSendProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return prev;
          }
          return prev + 10;
        });
      }, 300);

      // API call
      const res = await sendBulkWhatsApp(payload, activeBranchId);

      clearInterval(progressInterval);
      setSendProgress(100);

      if (res.statusCode === 200) {
        showSnackbar(`WhatsApp messages sent successfully to ${checkedClients.length} clients`, 'success');

        // Reset everything after success
        setTimeout(() => {
          dispatch(clearCheckedClients());
          setOpenConfirmationDialog(false);
          setOpenWhatsAppDialog(false);
          setSelectedTemplate(null);
          setIsSending(false);
          setSendProgress(0);
        }, 2000);

      } else {
        throw new Error(res.message || 'Failed to send WhatsApp messages');
      }
    } catch (error) {
      console.error('WhatsApp sending error:', error);
      setSendError(error.message);
      showSnackbar(error.message, 'error');
      setIsSending(false);
      setSendProgress(0);
    }
  };

  // Template confirmation handler
  const handleTemplateConfirm = (templateWithVariables) => {
    console.log('Template confirmed:', templateWithVariables);

    // Validate template variables before confirmation (skip header variables)
    const missingVariables = templateWithVariables.variables.filter((variable, index) => {
      const varType = templateWithVariables.variableTypes?.[variable];
      if (varType && varType.type !== 'text') return false; // skip header vars
      const varKey = `var_${index + 1}`;
      return !templateWithVariables.variableValues?.[varKey]?.trim();
    });

    if (missingVariables.length > 0) {
      setValidationError(`Please fill all required variables: ${missingVariables.join(', ')}`);
      return;
    }

    setSelectedTemplate(templateWithVariables);
    setValidationError('');
    setOpenConfirmationDialog(true);
  };

  const fetchWhatsAppTemplates = async () => {
    try {
      setLoading(true);
      const res = await getWhatsAppTemplates();
      console.log(res, 'resssssssss');

      const templatesData = res?.templates?.data || res?.data;

      if (templatesData && Array.isArray(templatesData)) {
        // Filter only approved templates - nested structure ke according
        const approvedTemplates = templatesData.filter(template => {
          // Check if template has languages array and first language has APPROVED status
          return template.languages &&
            template.languages.length > 0 &&
            // template.languages[0].status === "APPROVED";
                        template.languages[0].status?.toUpperCase() === "APPROVED";
        });

        console.log('Approved Templates:', approvedTemplates);
        setTemplates(approvedTemplates);
        setOpenWhatsAppDialog(true);
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch templates',
          messageType: 'error'
        });
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
      setShowMessage({
        message: 'Failed to fetch templates',
        messageType: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
  console.log(templates, 'templates')

  const handleManualClearSelection = () => {
    dispatch(clearCheckedClients());
  };

  // ✅ MODIFY search handler to preserve selection
  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setSearch(e.target.value.trimStart()));
    // Selection automatically preserve hoga kyunki slice mein change kar diya hai
  };

  // Cleans pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').trim();

    // If it looks like a phone number, remove spaces, dashes, brackets and +91
    if (/^[+\d\s\-()]+$/.test(pasted)) {
      pasted = pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '');
    }

    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(setSearch(next));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(setSearch(trimmed));
    }
  };

  // ✅ ADD reset function for clients
  const resetCheckedClients = () => {
    dispatch(clearCheckedClients());
  };
  // ✅ ADD useEffect for dialog close and filter changes
  useEffect(() => {
    // WhatsApp dialog close hone par reset
    if (!openWhatsAppDialog && !openConfirmationDialog) {
      resetCheckedClients();
    }
  }, [openWhatsAppDialog, openConfirmationDialog]);


  return (
    <PageContainer title="Client History" description="This contains all products">
  <DashboardCard2 title="Client Management">
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'flex-end', 
      marginBottom: '1.7rem' 
    }}>
      {/* Left side - Show per page */}
      <div>
        <InputLabel>Show per page</InputLabel>
        <Select
          style={{
            borderRadius: '7px',
            border: '0.5px solid #6174DD',
            padding: '4px 12px',
            background: '#FFF',
            height: '40px',
            width: '100px'
          }}
          value={pagination.limit}
          onChange={handleLimitChange}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={200}>200</MenuItem>
           <MenuItem value={1000000}>All</MenuItem>
        </Select>
      </div>

      {/* Right side - Search, Filter and Bulk Upload button */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        gap: '0.5rem'
      }}>
        {/* Search */}
  <div style={{ width: '170px' }}>
          <InputLabel>Search</InputLabel>
          <div 
            className="search-input" 
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              border: '0.5px solid #6174DD',
              borderRadius: '7px',
              padding: '4px 12px',
              background: '#FFF',
              height: '40px',
              minWidth: '170px'
            }}
            onClick={() => document.getElementById('search-input').focus()}
          >
            <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
            <input
              id="search-input"
              type="text"
              placeholder="Search Clients..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              onPaste={handleSearchPaste}
              onBlur={handleSearchBlur}
              style={{ 
                flex: 1, 
                border: 'none', 
                outline: 'none',
                background: 'transparent',
                marginLeft: '0.5rem'
              }}
            />
            {filters.search && (
              <IconButton
                onClick={() => {
                  dispatch(setSearch(''));
                }}
                style={{ padding: 1 }}
              >
                <ClearIcon style={{
                  color: '#000',
                  marginRight: '-0.2rem',
                  marginTop: '0.1rem',
                  fontSize: '1.1rem'
                }} />
              </IconButton>
            )}
          </div>
        </div>

        {/* Filter */}
        <div style={{ width: 'auto', minWidth: '120px' }}>
          <Cfilter
            options={filterOptions}
            value={[...filters.genderBy, ...filters.sortBy, ...(filters.showLossClient ? ['showLossClient'] : [])]}
            onChange={handleFilterChange}
            placeholder="Filters"
          />
        </div>

        {/* Bulk Client Upload button */}
        {/* <div>
          <Button
            variant="contained"
            color="primary"
            target="_blank"
            sx={{ 
              background: '#6174DD',
              height: '40px',
              minWidth: '160px'
            }}
            onClick={openModal}
          >
            Bulk Client Upload
          </Button>
        </div> */}
    <div>
      <BulkUploadClientDialog
        onUploaded={() => getData(filters.showLossClient)}
        existingClients={clients}
        branchData={branchData}
      />
    </div>
      </div>
    </div>

    {/*----------------------Modal Dialog-------------------*/}
    {/* <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create Many Client</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <Box p={2}>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
        </Box>
        {loading && <ShowLoader value={loading} />}
        <Box p={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ml: 2 }}
            onClick={downloadExcelTemplate}
          >
            <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
            Sample Download
          </Button>
        </Box>
      </form>
    </Dialog> */}
    
    {/* updated client upload dialog with preview and validation */}

    {/* -------------------------table start-------------------------- */}

    {loading ? (
      <ShowLoader />
    ) : filteredClients && filteredClients.length > 0 ? (
      <>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <FieldData
                getData={() => getData(filters.showLossClient)}
              />
            </Grid>
          </Grid>
        </Box>
      </>
    ) : (
      'No data found'
    )}

    {/* Pagination */}
    <Box display={'flex'} justifyContent={'flex-end'} mt={2}>
      <Pagination
        count={Math.ceil(pagination.total / pagination.limit)}
        page={pagination.page}
        color="primary"
        onChange={(e, newPage) => dispatch(setPage(newPage))}
        disabled={pagination.total === 0}
      />
    </Box>

    {/* ✅ UPDATE Selected Clients Card with Clear Button */}
    {checkedClients.length > 0 && (
      <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }} style={{ marginTop: '30px', width: '100%', height: '95px' }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" padding={'5px'}>
            <Box style={{ padding: '5px' }}>
              <Typography variant="h6" gutterBottom>
                📱 Ready to Send WhatsApp
              </Typography>
              <Box display="flex" gap={2} alignItems="center" marginTop={'10px'}>
                <Chip
                  label={`${checkedClients.length} clients selected`}
                  color="primary"
                  variant="outlined"
                />
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleManualClearSelection}
                  size="small"
                >
                  Clear Selection
                </Button>
                <Typography variant="body2" color="text.secondary">
                  {checkedClients.length} clients will receive WhatsApp messages
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              startIcon={<WhatsAppIcon />}
              onClick={fetchWhatsAppTemplates}
              sx={{
                background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
                borderRadius: '8px',
                px: 3,
                '&:hover': {
                  background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
                }
              }}
            >
              Send Bulk WhatsApp
            </Button>
          </Box>
        </CardContent>
      </Card>
    )}

    {/* Template Selection Dialog */}
    <TemplateSelectionDialog
      open={openWhatsAppDialog}
      templates={templates}
      onClose={() => {
        if (!isSending) {
          setOpenWhatsAppDialog(false);
          setSelectedTemplate(null);
          setSendError(null);
          setValidationError('');
          resetCheckedClients();
        }
      }}
      onConfirm={handleTemplateConfirm}
      isSending={isSending}
      sendProgress={sendProgress}
      sendError={sendError}
      validationError={validationError}
      setSendError={setSendError}
    />

    {/* Confirmation Dialog */}
    <Dialog
      open={openConfirmationDialog}
      onClose={() => {
        !isSending && setOpenConfirmationDialog(false)
        resetCheckedClients();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
          <WhatsAppIcon color="success" />
          <Typography variant="h6">
            {isSending ? `Sending... ${sendProgress}%` : 'Confirm WhatsApp Send'}
          </Typography>
        </Box>
        {isSending && (
          <LinearProgress
            variant="determinate"
            value={sendProgress}
            sx={{ mt: 1 }}
          />
        )}
      </DialogTitle>

      <DialogContent>
        {sendError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {sendError}
          </Alert>
        )}

        <Alert severity="info" sx={{ mb: 2 }}>
          You're about to send WhatsApp messages to {checkedClients.length} clients
        </Alert>

        {selectedTemplate && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Template: <strong>{selectedTemplate.name}</strong>
            </Typography>

            <Box mt={2}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Message Preview:
              </Typography>
              <Card variant="outlined" sx={{ p: 2, bgcolor: '#fafafa' }}>
                <Typography variant="body2" whiteSpace="pre-wrap">
                  {selectedTemplate.bodyText || 'No message content'}
                </Typography>
              </Card>
            </Box>

            {selectedTemplate.variables.length > 0 && (
              <Box mt={2}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Variables to be sent:
                </Typography>
                {selectedTemplate.variables.map((variable, index) => (
                  <Chip
                    key={variable}
                    label={`${variable}: ${selectedTemplate.variableValues?.[`var_${index + 1}`] || 'Not set'}`}
                    size="small"
                    sx={{ mr: 1, mb: 1 }}
                    variant="outlined"
                    color={selectedTemplate.variableValues?.[`var_${index + 1}`] ? "success" : "default"}
                  />
                ))}
              </Box>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={() => !isSending && setOpenConfirmationDialog(false)}
          variant="outlined"
          sx={{ borderRadius: '6px' }}
          disabled={isSending}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSendBulkWhatsApp}
          variant="contained"
          startIcon={<WhatsAppIcon />}
          disabled={isSending}
          sx={{
            background: isSending
              ? '#ccc'
              : 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
            borderRadius: '6px',
            px: 3,
            '&:hover': isSending ? {} : {
              background: 'linear-gradient(135deg, #128c7e 0%, #25d366 100%)'
            },
            '&:disabled': {
              background: '#ccc'
            }
          }}
        >
          {isSending ? `Sending... ${sendProgress}%` : `Send to ${checkedClients.length} Clients`}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Snackbar for notifications */}
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={() => setSnackbar({ ...snackbar, open: false })}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  </DashboardCard2>
</PageContainer>
  );
};

export default AllClients;